import { render, staticRenderFns } from "./ShopingCart.vue?vue&type=template&id=d74458fe&scoped=true"
import script from "./ShopingCart.vue?vue&type=script&lang=js"
export * from "./ShopingCart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d74458fe",
  null
  
)

export default component.exports